import { render, staticRenderFns } from "./WizardEditCampaign.vue?vue&type=template&id=b4a52ce0&scoped=true&"
import script from "./WizardEditCampaign.vue?vue&type=script&lang=js&"
export * from "./WizardEditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./WizardEditCampaign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WizardEditCampaign.vue?vue&type=style&index=1&id=b4a52ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a52ce0",
  null
  
)

export default component.exports